import { ROUTER_INITIATED } from './mutations'

export default {
  initiated ({ commit }) {
    commit(ROUTER_INITIATED)
  }
}
